// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UTvi","right":"styles_right__2ww-9"};